<template>
  <data-layout :active="2">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Founding History</h4>
        </div>
        <div class="card-body">
          <p>
            This table contains all historical funding rates on the exchange
          </p>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Start Time</th>
                  <th>Symbol</th>
                  <th>Founding Interval</th>
                  <th>Funding Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
                <tr>
                  <td>10th March 2020</td>
                  <td>BTC - USDO</td>
                  <td>Every 8 Hours</td>
                  <td>0.0100%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </data-layout>
</template>

<script>
import DataLayout from "../../../components/Layouts/DataLayout.vue";
export default {
  components: { DataLayout },
};
</script>
